"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Section = exports.SectionType = void 0;
const react_1 = __importDefault(require("react"));
const table_1 = __importDefault(require("antd/lib/table"));
const Form_1 = __importDefault(require("../../../Form"));
const EditableTableCell_1 = require("../EditableTableCell");
var SectionType;
(function (SectionType) {
  SectionType["Form"] = "form";
  SectionType["Table"] = "table";
})(SectionType = exports.SectionType || (exports.SectionType = {}));
const SectionContent = react_1.default.forwardRef((props, ref) => {
  switch (props.type) {
    case SectionType.Table:
      {
        const _a = props.data || {},
          _a$rowComponent = _a.rowComponent,
          rowComponent = _a$rowComponent === void 0 ? EditableTableCell_1.EditableTableFormRow : _a$rowComponent,
          _a$cellComponent = _a.cellComponent,
          cellComponent = _a$cellComponent === void 0 ? EditableTableCell_1.EditableTableCell : _a$cellComponent,
          tableProps = __rest(_a, ["rowComponent", "cellComponent"]);
        return react_1.default.createElement(table_1.default, Object.assign({}, tableProps, {
          ref: ref,
          components: {
            body: {
              row: rowComponent,
              cell: cellComponent
            }
          }
        }));
      }
    case SectionType.Form:
      return react_1.default.createElement(Form_1.default, Object.assign({}, props.data, {
        wrappedComponentRef: ref
      }));
    default:
      return null;
  }
});
exports.Section = react_1.default.forwardRef((_a, ref) => {
  var _a$hidden = _a.hidden,
    hidden = _a$hidden === void 0 ? false : _a$hidden,
    _a$container = _a.container,
    Container = _a$container === void 0 ? react_1.default.Fragment : _a$container,
    title = _a.title,
    header = _a.header,
    footer = _a.footer,
    key = _a.key,
    contentProps = __rest(_a, ["hidden", "container", "title", "header", "footer", "key"]);
  return hidden ? null : react_1.default.createElement(Container, {
    key: key,
    title: title
  }, header, react_1.default.createElement(SectionContent, Object.assign({}, contentProps, {
    ref: ref
  })), footer);
});
exports.default = exports.Section;